<div class="cable-message-container">
  <img [ngClass]="{'visible': current === 0}" src="/assets/png/stella_connected-min.png">
  <img [ngClass]="{'visible': current === 1}" src="/assets/png/stella_disconnected-min.png">
</div>
